// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xi_a bhl_vn bhl_vf bhl_xb bhl_re bhl_tp bhl_qv"};